<template>
  <div id="overlay" :style="{'display' : spinnerOn ? 'block' : 'none'}">
    <div class="row inner align-items-center">
      <div class="col">
        <i class="fa fa-4x fa-spinner fa-spin"></i>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'spinner',
    props: {
      spinnerOn: false
    }
  }
</script>
<style scoped>
  i {
    padding: 24px;
  }
</style>



// WEBPACK FOOTER //
// Spinner.vue?89f72328